import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import CheckboxField from 'components/fields/CheckboxField';

import { collapsePrintNavigation } from 'redux/modules/routerParams';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  listItem: {
    padding: '12px 20px 12px 30px',
    color: theme.palette.secondary['300'],
    [theme.breakpoints.down('sm')]: {
      padding: '12px 8px',
    },
  },
  listItemActive: {
    color: theme.palette.primary['600'],
  },
  listItemTextRoot: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  listItemTextPrimary: {
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.7, 14),
    lineHeight: pxToEm(21, 14),
    color: 'inherit',
  },
  checkboxField: {
    marginTop: -14,
    marginBottom: -14,
  },
});

const NavigationItem = ({
  title, href, search, state, router, location, history, classes, actions, id, selectable,
}) => (
  <ListItem
    button
    disableGutters
    className={classNames(classes.listItem, {
      [classes.listItemActive]: href === router.location.pathname
        && (!search || `?${search}` === location.search),
    })}
    onClick={() => {
      history.push({
        pathname: href,
        search: search || location.search,
        ...state ? { state } : {},
      });
      setTimeout(() => {
        actions.collapsePrintNavigation();
      }, 100);
    }}
  >
    {selectable &&
      <Field
        className={classes.checkboxField}
        id={id}
        name={id}
        component={CheckboxField}
        onClick={(event) => {
          event.stopPropagation();
        }}
      />
    }
    <ListItemText
      primary={title}
      classes={{
        root: classes.listItemTextRoot,
        primary: classes.listItemTextPrimary,
      }}
    />
  </ListItem>
);

NavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  search: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object,
  actions: PropTypes.shape({
    collapsePrintNavigation: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
    listItemActive: PropTypes.string.isRequired,
    listItemTextPrimary: PropTypes.string.isRequired,
  }).isRequired,
};

NavigationItem.defaultProps = {
  state: null,
  search: null,
};

function mapStateToProps(state) {
  return {
    router: state.router,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    collapsePrintNavigation,
  }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NavigationItem)),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/PrintNavigation/PrintNavigationItem.js